import React from 'react';
const bonuses = [{
  emoji: '⚽',
  title: 'Guía de Calentamiento Específico',
  desc: 'Rutinas para activar y prevenir lesiones.'
}, {
  emoji: '📅',
  title: 'Plan Anual Express',
  desc: 'Una hoja de ruta lista para organizar tu agenda de competencia.'
}, {
  emoji: '✅',
  title: 'Fichas de Evaluación',
  desc: 'Autoevaluaciones para que tus jugadores midan su progreso.'
}, {
  emoji: '🥗',
  title: 'Guía de Nutrición Básica',
  desc: 'Qué comer antes y después de cada partido.'
}, {
  emoji: '🏆',
  title: 'Certificado Profesional',
  desc: 'Para demostrar tu formación en metodología EDULABS.'
}, {
  emoji: '📝',
  title: 'Reglamento Interno',
  desc: 'Documento listo para firmar y profesionalizar el compromiso del equipo.'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <div className="text-center mb-14" data-id="element-16">
          <span className="inline-block text-secondary font-bold text-sm tracking-widest uppercase mb-3" data-id="element-17">
            🔥 6 Bonus Incluidos
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-3 tracking-tight" data-id="element-18">
            Suma estos extras{' '}
            <span className="text-secondary" data-id="element-19">sin pagar más</span>
          </h2>
          <p className="text-text-sec text-base sm:text-lg font-medium" data-id="element-20">
            Valorados en{' '}
            <span className="text-badge-red font-black line-through" data-id="element-21">$39</span>{' '}
            — Gratis Hoy
          </p>
        </div>

        <div className="space-y-4" data-id="element-22">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt/80 backdrop-blur-sm rounded-2xl border border-border-light p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-5 transition-all hover:-translate-y-1 hover:border-secondary/30 hover:shadow-[0_10px_30px_rgba(245,158,11,0.1)] group" data-id="element-23">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-secondary/20 to-secondary/5 border border-secondary/20 flex items-center justify-center flex-shrink-0 text-2xl shadow-inner group-hover:from-secondary/30 transition-colors" data-id="element-24">
                {bonus.emoji}
              </div>

              <div className="flex-1 min-w-0" data-id="element-25">
                <h4 className="text-text-main font-bold text-lg sm:text-xl mb-0.5" data-id="element-26">
                  {bonus.title}
                </h4>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-27">
                  {bonus.desc}
                </p>
              </div>

              <span className="bg-secondary/10 text-secondary border border-secondary/20 px-3 py-1.5 rounded-lg font-black text-sm sm:text-base flex-shrink-0 shadow-[0_0_10px_rgba(245,158,11,0.2)]" data-id="element-28">
                GRATIS
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}